import React, { createContext, useState } from "react";
import { useDispatch } from 'react-redux';
import EdgeOrREST from "./EdgeOrREST";
import notificationActions from './store/actions/notificationActions';
import { setAxiosHeaders } from './API/services/axios.client';

const AuthContext = createContext();

function AuthProvider(props) {
    const dispatch = useDispatch();
    const [authed, setAuthed] = useState(false);
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [companyId, setCompanyId] = useState(null);
    const [isPasswordExpired, setIsPasswordExpired] = useState(false);
    const [is2FAEnabled, setIs2FAEnabled] = useState(false);
    const [is2FAAuthenticated, setIs2FAAuthenticated] = useState(false);
    const [isAuthResolving, setIsAuthResolving] = useState(false);

    const login = async (token, userId, companyId, isPasswordExpired, twoFactorState = null) => {
        dispatch(notificationActions.ResetNotificationHistory());
        setIsAuthResolving(true);
        setAuthed(true);
        setToken(token);
        setUserId(userId);
        setCompanyId(companyId);
        setIsPasswordExpired(isPasswordExpired);

        if (twoFactorState?.requiresTwoFactor) {
            setIs2FAEnabled(true);
            setIs2FAAuthenticated(!!twoFactorState.isTwoFactorVerified);
            setIsAuthResolving(false);
            return;
        }

        return new Promise((resolve) => {
            EdgeOrREST(null, "VALIDATE_BYPASS_TOKEN", (response) => onValidateBypassToken(response, resolve), { auth: token });
        });
    };

    const onValidateBypassToken = (response, onResolved = null) => {
        const responseData = response?.data ?? response;
        const isSuccessfulResponse = response?.status ? response.status == 200 : !!responseData;

        if (!isSuccessfulResponse || !responseData?.valid) {
            setIs2FAEnabled(false);
            setIs2FAAuthenticated(false);
            setIsAuthResolving(false);
            onResolved?.();
            return;
        }

        setIs2FAEnabled(true);
        setIs2FAAuthenticated(!responseData.bypassExpired);
        setIsAuthResolving(false);
        onResolved?.();
    }

    const logout = () => {
        setAuthed(false);
        setToken(null);
        setUserId(null);
        setCompanyId(null);
        setIsPasswordExpired(false);
        setIs2FAEnabled(false);
        setIs2FAAuthenticated(false);
        setIsAuthResolving(false);
    };

    const complete2FASetup = (session = {}) => {
        dispatch(notificationActions.ResetNotificationHistory());
        if (session.token) {
            setToken(session.token);
            setAxiosHeaders(session.token);
            window.localStorage.setItem("token", session.token);
        }
        if (session.userId) {
            setUserId(session.userId);
        }
        if (session.companyId) {
            setCompanyId(session.companyId);
        }
        setIs2FAEnabled(true);
        setIs2FAAuthenticated(true);
        setIsAuthResolving(false);
    };

    const value = {
        authed,
        token,
        userId,
        companyId,
        isPasswordExpired,
        is2FAEnabled,
        is2FAAuthenticated,
        isAuthResolving,
        login,
        logout,
        complete2FASetup,
    };

    return <AuthContext.Provider value={value} {...props} />;
}

export { AuthContext, AuthProvider };
